import { Component, Input, Output, EventEmitter } from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
    selector: 'white-label-section-controls',
    templateUrl: './white-label-section-controls.component.html',
    imports: [
        NgStyle
    ],
    standalone: true
})
export class WhiteLabelSectionControlsComponent {
    @Input() index: number = 0;
    @Input() position: 'top' | 'bottom' = 'top';

    @Output() add = new EventEmitter<number>();

    onAddClick() {
        this.add.emit(this.index); // pass the index up
    }
}
